// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","578":"c75911a9","622":"464dec73","977":"0aa2c955"}[chunkId] + ".chunk.js";
};